import { useTranslation } from "react-i18next";
import { Position } from "../../interfaces";
import PositionsSizeDetails from "./PositionsSizeDetails";

const UploadInstructions = ({ positions }: { positions: Position[] }) => {
  const { t } = useTranslation();
  return (
    <div>
      <div>
        <h4 className="section-heading pt-20 f-w-700"> {t("stepsToUpload")}</h4>
        <ul className="ul_with_numbers pl-18">
          <li className="f-weight-400 f-14"> {t("uploadStep1")}</li>
          <li className="f-weight-400 f-14"> {t("uploadStep2")}</li>
          <li className="f-weight-400 f-14"> {t("uploadStep3")}</li>
          <li className="f-weight-400 f-14"> {t("uploadStep4")}</li>
          <li className="f-weight-400 f-14"> {t("uploadStep5")}</li>
          <li className="f-weight-400 f-14"> {t("uploadStep6")}</li>
        </ul>
      </div>
      <PositionsSizeDetails positions={positions} />
    </div>
  );
};

export default UploadInstructions;
